import api from "./index";

/**
 * @typedef { ('in_progress' | 'api_verified' | 'manually_verified' | 'succeeded' | 'failed') } DocumentStatus
 * @typedef { ('identity_recto' | 'identity_verso' | 'proof_of_address' | 'kbis') } DocumentType
 * @typedef { ('not_started' | 'in_progress' | 'manual_verification_required' | 'failed' | 'succeeded') } VerificationStatus
 */

export default {
    /**
     * getStatus
     * Gets the global verification status of the goup and individual documents statuses
     * @param {String} id the group id
     * @param {Object} params other params for the request
     */

    getStatus(groupId, params) {
        return api
            .get(`/verifications/${groupId}/status`, {
                params: params,
                skipStatuses: [404]
            })
            .then(response => {
                return response.data
            })
    },
    /**
     * getUploadUrl
     * Gets a presigned URL to upload verification document to
     *
     * @param {Object} params
     * @param {Number} params.group_id
     * @param {String} params.document_extension the file exension without leading "." e.g. "pdf", "jpg", "png"
     * @param {DocumentType} params.document_type
     *
     */
    getUploadUrl({ group_id, document_extension, document_type }) {
        return api
            .post('/verifications/upload-document-path', {
                group_id,
                document_extension,
                document_type,
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * triggerVerification
     *
     * @param {Object} params
     * @param {Number} [params.group_id] The id of the group to grigger verification. Provide either this or the verification id
     * @param {Number} [params.verification_id] The id of the verification you want to trigger. Not required if you provide a group_id
     *
     */
    triggerVerification({ group_id, verification_id }) {
        return api.post('/verifications/trigger', {
            group_id,
            verification_id,
        }).then(response => {
            return response.data
        })
    },

    //
    // ADMIN ROUTES
    //

    /**
     * Show document
     * /!\ Reserved to admin
     * returns a presigned URL to show the actual file
     * @param {String} documentId
     * @param {DocumentType} documentType
     * @param {Object} params other params for the request
     *
     */

    showDocument(documentId, documentType, params) {
        return api
            .get(`/verifications/${documentId}/consult-document/${documentType}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },
    /**
     * Show document
     * @param documentId
     * @param params
     */

    updateDocumentStatus(documentId, params) {
        return api
            .patch(`/documents/${documentId}/status`, params)
            .then(response => {
                return response.data
            })
    }
}